<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import ViewFilters from '@/components/ViewFilters'
import YearsDropdown from '@/components/YearsDropdown'
import SchoolsDropdown from '@/components/admin/SchoolsDropdown'

@Component({
    // components: {
    //     ViewFilters,
    //     YearsDropdown,
    //     SchoolsDropdown
    // },
    props: {
        userRole: String,
        selectedSchool: Object,
        evaluators: Array,
        grades: Array,
        subjects: Array
    }
})

export default class TableFilters extends Vue {
    
    filters = {
        grades: [],
        subjects: [],
        evaluators: []
    }

}
</script>

<template>
    <div class="filters"
      v-if="userRole !== 'Teacher' && selectedSchool.dbn">
      <!-- <div class="filter view-by">
        <ViewFilters v-if="selectedSchool.dbn" :user-role="userRole"/>
      </div> -->
      <div class="filter">
        <span>Evaluator</span>
        <el-select v-model="filters.evaluators" multiple collapse-tags placeholder="Select an Evaluator">
            <el-option 
            v-for="item in evaluators" 
            :key="item.name" 
            :label="item.name" 
            :value="item.name">
            </el-option>
        </el-select>
      </div>
      <div class="filter">
        <span>Grade</span>
        <el-select v-model="filters.grades" multiple collapse-tags placeholder="Select a Grade">
            <el-option
                v-for="item in grades"
                :key="item.name"
                :label="item.name"
                :value="item.name">
            </el-option>
        </el-select>
      </div>
      <div class="filter">
        <span>Subject</span>
        <el-select v-model="filters.subjects" multiple collapse-tags placeholder="Select a Subject">
            <el-option 
            v-for="item in subjects" 
            :key="item.name" 
            :label="item.name" 
            :value="item.name">
            </el-option>
        </el-select>
      </div>
      <!-- <div class="filter">
        <span>Year</span>
        <YearsDropdown v-if="userRole !== 'Teacher' && selectedSchool.dbn"
        :dropdown-years="dropdownYears"
        :user-role="userRole">
        </YearsDropdown>
      </div>
      <div class="school-filter">
        <span>School</span>
        <SchoolsDropdown v-if="userRole !== 'Teacher' && selectedSchool.dbn" :schools="schools"></SchoolsDropdown>
      </div> -->
      
    </div>
</template>

<style lang="scss" scoped>

.filters {
    font-family: 'museo_sans', sans-serif;
    display: flex;
    padding: 1em 0;
    margin-bottom: 1em;
    .filter {
        display: flex;
        flex-direction: column;
        width: 191px;
        margin-right: 32px;
        &.view-by {
            margin-right: -40px;
        }
        span {
            margin-bottom: 5px;
            color: #4a4a4a;
            font-size: 14px;
        }
    }
    .school-filter {
        width: 350px;
        span {
            display: block;
            margin-bottom: 5px;
            color: #4a4a4a;
            font-size: 14px;
        }
    }
}

</style>

